import { type ComponentProps } from "react";

export const Share = (props: ComponentProps<"svg">) => (
  <svg
    width="1.125rem"
    height="1.125rem"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3066 7.59814H15.6897C16.5642 7.59814 17.2725 8.30571 17.2725 9.17823V17.9164C17.2725 18.7875 16.5635 19.4965 15.6897 19.4965H4.5772C3.70263 19.4965 2.99439 18.7889 2.99439 17.9164V9.17823C2.99439 8.30707 3.70332 7.59814 4.5772 7.59814H6.96023V8.78832H4.18456V18.307H16.0823V8.78832H13.3066V7.59814Z"
      fill={props?.fill ?? "var(--primary-color)"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1334 2.83936C9.80486 2.83936 9.53833 3.16791 9.53833 3.43445V12.5563C9.53833 12.8849 9.80485 13.1514 10.1334 13.1514C10.462 13.1514 10.7285 12.8229 10.7285 12.5563V3.43445C10.7285 3.10589 10.462 2.83936 10.1334 2.83936Z"
      fill={props?.fill ?? "var(--primary-color)"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.7128 2.27443C9.48036 2.50687 9.52467 2.92746 9.7128 3.11559L12.237 5.6398C12.4695 5.87224 12.8457 5.87224 13.0782 5.6398C13.3106 5.40736 13.2663 4.98677 13.0782 4.79864L10.554 2.27443C10.3215 2.04199 9.94524 2.04199 9.7128 2.27443Z"
      fill={props?.fill ?? "var(--primary-color)"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.18832 5.63973C7.42076 5.87217 7.84136 5.82787 8.02949 5.63973L10.5537 3.11553C10.7861 2.88309 10.7861 2.5068 10.5537 2.27436C10.3213 2.04192 9.90067 2.08623 9.71253 2.27436L7.18832 4.79857C6.95588 5.03101 6.95588 5.40729 7.18832 5.63973Z"
      fill={props?.fill ?? "var(--primary-color)"}
    />
  </svg>
);
